import React, { Component } from 'react';
import renderHTML from 'react-render-html';


class ParrillaPost extends Component {

  constructor(props){
    super(props)
    this.state = {
      showImage:true
    }
    this.showImagen = this.showImagen.bind(this)
  }

  showImagen(){
    this.setState({
        showImage: !this.state.showImage
    });
  }

  render() {
      console.log(this.state.showImage)
    return (
        <div className="content_item">
            <div className="img-item">
                {
                    this.props.imgItem && this.state.showImage &&
                    <img
                        src={this.props.imgItem}
                        onError={(e)=>{
                            console.log(e)
                            this.showImagen()
                        }
                        }
                        alt="text"
                    />
                }
            </div>
            <div className="text-item">
                {
                    this.props.titleItem &&
                    <h3>{renderHTML(this.props.titleItem)}</h3>
                }
                <div className="btn-more"><p>Ver más</p></div>
            </div>
        </div>
    )
  }
}

export default ParrillaPost



// WEBPACK FOOTER //
// ./src/Parrilla_item.js